export default {
    title: "購物車",
    spec: "規格",
    table1: "商品名稱",
    table2: "單價",
    table3: "數量",
    table4: "合計",
    table5: "顏色",
    table6: "刪除",
    delAllBtn: "刪除選中商品",
    total1: "共",
    total2: "件商品",
    total3: "總計：",
    submitBtn: "結算",
    errmsg1: "您還未勾選商品！",
    errmsg2: "您沒有權限修改或添加地址，請聯繫管理員！",
    errmsg3: "您還未選擇地址！",
    errmsg4: "您沒有權限下訂單，請聯繫管理員！",
    errmsg5: "商品庫存不足，請聯繫管理員",
	errmsg6: "當前訂單價格已超低於限定金額！",
    confirmMsg: "是否進入結算頁面？",
    ordertitle1: "確認收貨地址",
    ordertitle2: "確認訂單信息",
    address1: "添加新地址",
    address2: "顯示更多地址",
    address3: "收起地址",
    address4: "修改地址",
    address5: "添加地址",
    form1: "收貨人",
    form2: "聯繫電話",
    form3: "詳細地址",
    form4: "電子郵箱",
    form5: "傳真",
    isdefault: "設為默認地址",
    rule1: "請輸入收貨人姓名",
    rule2: "請輸入收貨地址",
    rule3: "請輸入聯繫電話",
    rule4: "請輸入電子郵箱",
    branch1: "選擇部門",
    branch2: "備註（50漢字內）",
    backBtn: "返回購物車",
    total4: "商品件數：",
    total5: "運費：",
    total6: "價格總計：",
    total7: "折後價格：",
    total8: "件",
    succmsg: "添加成功，請在訂單狀態中查看訂單詳情！",
    errmsg: "您當月或當前訂單價格已超過限定金額！",
}